import React from "react";
import { team } from "../../dummydata";

const TeamCard = () => {
  return (
    <div className="flex justify-center my-5">
      <div className="p-2 sm:w-5/6">
        <div className=" border-2 p-6 rounded-lg my-10 shadow-xl">
          <p className="my-4 text-base md:text-lg">
            Beim Pflege- und Betreuungsdienst Malik steht der Mensch im Mittelpunkt – mit all seinen Bedürfnissen, Wünschen und seiner Würde. Unser Anspruch: Pflege, die nicht nur professionell, sondern auch menschlich und zukunftsorientiert ist.
          </p>
          <p className="my-4 text-base md:text-lg">
            Idee, Pflege besser, persönlicher und qualitativ hochwertiger zu gestalten, war von Anfang an das Anliegen unseres Geschäftsführers Herrn Malik. Mit viel Engagement, klarer Vision und einem offenen Ohr für die Herausforderungen des Pflegealltags treibt er gemeinsam mit seinem Team die Weiterentwicklung unserer Leistungen stetig voran.
          </p>
          <p className="my-4 text-base md:text-lg">
            Wir glauben daran, dass Pflege mehr ist als nur eine Aufgabe – sie ist Verantwortung, Vertrauen und Nähe. Deshalb setzen wir auf ein starkes Miteinander im Team und auf Fachkräfte, die mit Herz bei der Sache sind
          </p>
          <p className="my-4 text-base md:text-lg">
            Unser Team besteht aus erfahrenen Pflegefachkräften, engagierten Pflegehelferinnen, einfühlsamen Betreuungskräften, fleißigen Hauswirtschaftskräften und einer zuverlässigen Verwaltung, die im Hintergrund alles am Laufen hält. Gemeinsam sind wir bestens aufgestellt, um flexibel und kompetent auf jede Situation zu reagieren.
          </p>
          <p className="my-4 text-base md:text-lg">
            Entscheiden Sie sich für den Pflege- und Betreuungsdienst Malik – für eine Betreuung, die geprägt ist von Qualität, Respekt und echter Menschlichkeit.
          </p>
          <p className="my-4 text-base md:text-lg">
            Unser Motto: Maximale Lebensqualität
          </p>
          <p className="my-4 text-base md:text-lg">
            Warum „maximale Lebensqualität“? Weil wir überzeugt sind, dass jeder Mensch – unabhängig von Alter oder Einschränkungen – das Beste aus seinem Alltag herausholen sollte. Unser Ziel ist es, unsere Klientinnen und Klienten in ihrer gewohnten Umgebung so zu unterstützen, dass sie ein möglichst selbstbestimmtes, erfülltes und würdevolles Leben führen können. Wir schauen nicht nur auf das, was fehlt – sondern auf das, was möglich ist. Gemeinsam holen wir das Beste aus jedem Tag heraus – mit Herz, Fachwissen und einem ehrlichen Lächeln.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
